import React from "react";
import PropTypes from "prop-types";

import { Breadcrumbs } from "./ApplicationShell";
import StatusBadge, { STATUS_TYPES } from "./StatusBadge";
import Tabs from "./Tabs";

const PackViewLayout = ({
  actions,
  activeTab,
  breadcrumbs,
  children,
  metadata = [],
  onTabChange,
  status,
  statusType = "secondary",
  tabs,
  title,
}) => {
  const activeLabel = tabs.find((tab) => tab.id === activeTab)?.label ?? "Pack content";

  return (
    <div className="wsm-pack-view">
      <header className="wsm-pack-view__header">
        {breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} />}
        <div className="wsm-pack-view__header-row">
          <div className="wsm-pack-view__identity">
            <div className="wsm-pack-view__title-row">
              <h1>{title}</h1>
              <StatusBadge type={statusType}>{status}</StatusBadge>
            </div>
            {metadata.length > 0 && (
              <dl className="wsm-pack-view__metadata">
                {metadata.map((item) => (
                  <div key={item.label}><dt>{item.label}</dt><dd>{item.value}</dd></div>
                ))}
              </dl>
            )}
          </div>
          {actions && <div aria-label="Pack actions" className="wsm-pack-view__actions">{actions}</div>}
        </div>
      </header>
      <Tabs activeId={activeTab} label="Pack sections" onChange={onTabChange} tabs={tabs} />
      <div aria-label={activeLabel} className="wsm-pack-view__panel" role="tabpanel">{children}</div>
    </div>
  );
};

PackViewLayout.propTypes = {
  actions: PropTypes.node,
  activeTab: PropTypes.string.isRequired,
  breadcrumbs: Breadcrumbs.propTypes.items,
  children: PropTypes.node.isRequired,
  metadata: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.node.isRequired })),
  onTabChange: PropTypes.func.isRequired,
  status: PropTypes.node.isRequired,
  statusType: PropTypes.oneOf(STATUS_TYPES),
  tabs: Tabs.propTypes.tabs,
  title: PropTypes.node.isRequired,
};

export default PackViewLayout;
